
import { createFileRoute, Outlet, Navigate } from '@tanstack/react-router';

function AuthLayout() {
  if (typeof window !== 'undefined' && localStorage.getItem('admin-auth') === 'true') {
    return <Navigate to="/admin" />;
  }
  return <Outlet />;
}

export const Route = createFileRoute('/(authentication)/auth/layout')({
  component: AuthLayout,
});
